import { AclEntry } from './acl-entry';
import { AclRole } from './acl-role';
import { Address } from './address';

/* Update most objects as interfaces */

export interface Account {
  id?: number;
  gender?: string;
  phone?: string;
  address?: Address;
  firstName?: string;
  lastName?: string;
  name?: string;
  email?: string;
  guid?: string;
  state?: string;
  activateEmailDate?: string;
  activateEmailMessage?: string;
  password?: string;
  createDate?: string;
  signinDate?: string;
  passwordChange?: boolean;
  permissions?: {
    app: number;
  };
  image?: any;
  aclRoles?: AclRole[];
  apiKey?: string;
  apiSecret?: string;
  type?: string;
  timezone?: string;
  aclEntries?: AclEntry[];
  digestFrequency?: number;
  fundUpdateNotification?: boolean;
  fundUpdateAllFunds?: boolean;
  updateNotificationFunds?: any[];
  fundAnomaliesEmails?: boolean;
  fundAnomaliesUpdate?: Date | string;
  fundAnomaliesNotificationSchedule?: string;
}
